// extracted by mini-css-extract-plugin
export default {"bold_input":"styles_bold_input__u7mHi"};